// window.addEventListener('load', function() {
//     let registrationForm = document.querySelector('.frcp-cf-form--registration');
//     let anotherStores = ['#another-store2', '#another-store3', '#another-store4', '#another-store5', '#another-store6', '#another-store7'];
//     let initializeStores = function(selector) {
//       if (registrationForm.querySelector(`a[href="${selector}"]`) != null) {
//         let el = registrationForm.querySelector(`a[href="${selector}"]`).closest('.frcp-cf-design').nextSibling;
//         for (i = 1; i <= 11; i++) {
//           el.style.display = "none";
//           el = el.nextSibling;
//         }
//         registrationForm.querySelector(`a[href="${selector}"]`).addEventListener('click', function(e) {
//           e.preventDefault();
//           let el = registrationForm.querySelector(`a[href="${selector}"]`).closest('.frcp-cf-design').nextSibling;
//           for (i = 1; i <= 11; i++) {
//             if (el.style.display == "none") {
//               el.style.display = "block";
//             } else {
//               el.style.display = "none";
//             }
//             el = el.nextSibling;
//           }
//         });
//         // registrationForm.querySelector('a[href="#another-store2"]').closest('.frcp-cf-design').nextSibling.style.display = 'none';
//       }
//     }
//     anotherStores.forEach(value => {
//       initializeStores(value);
//     });
  
//     const flatInput = document.querySelector(".flatpickr-input");
//     flatInput.flatpickr({
//         defaultDate: "today"
//     });
//     flatInput.dispatchEvent(new Event('input'));
  
//     // if (registrationForm.querySelector('[title="DATE SIGNED"]') != null) {
//     //   let date = new Date();
//     //   let month = '' + (date.getMonth() + 1),
//     //       day = '' + date.getDate(),
//     //       year = date.getFullYear();
  
//     //   if (month.length < 2) 
//     //       month = '0' + month;
//     //   if (day.length < 2) 
//     //       day = '0' + day;
//     //   registrationForm.querySelector('[title="DATE SIGNED"]').value = `${year}-${month}-${day}`;
//     // }
  
//     if (document.querySelector('input[title="RECEIVE EMAIL UPDATES FROM THE HOLIDAY SHOPPING CARD"]') != null) {
//       // document.querySelector('input[title="RECEIVE EMAIL UPDATES FROM THE HOLIDAY SHOPPING CARD"]').checked = true;
//       // document.querySelector('input[title="RECEIVE EMAIL UPDATES FROM THE HOLIDAY SHOPPING CARD"]').closest('.frcp-cf__label').dispatchEvent(new Event('click'));
//     }
  
//     document.querySelector('.frcp-cf-form-wrapper').style.opacity = '1';
//   });
  
function checkDonations(){
    let props = "";
    
    let donationWrapper = $(".custom-donation-wrapper");
    donationWrapper.attr("data-props", props);
    
    let donationSwatch = $(".custom-donation-swatch-input");
    let donationSwatchChecked = $(".custom-donation-swatch-input:checked");
  
    let donationGiftWrapper = $(".custom-donation-gift-wrapper");
    let donationGiftWrapperInputChecked = $(".custom-donation-gift-input:checked");
    
    let donationHonorWrapper = $(".custom-donation-honor-wrapper");
    let donationHonorDropdown = $(".custom-donation-honor-dropdown");
    
    let donationHonorNameWrapper = $(".custom-donation-honor-name-wrapper");
    let donationHonorNameInput = $(".custom-donation-honor-name-input");
  
    donationGiftWrapper.removeClass("active");
    donationHonorWrapper.removeClass("active");
    donationHonorNameWrapper.removeClass("active");
  
    if(donationSwatch.length > 0 && donationSwatchChecked.length > 0){
      donationGiftWrapper.addClass("active");
      props += donationSwatchChecked.val().trim();
      if(donationGiftWrapper.length > 0 && donationGiftWrapperInputChecked.length > 0 && donationGiftWrapperInputChecked.val().toLowerCase().trim() == "yes"){
        donationHonorWrapper.addClass("active");
        props += ",yes";
        if(donationHonorWrapper.length > 0 && donationHonorDropdown.val().toLowerCase().trim() == "other"){
          donationHonorNameWrapper.addClass("active");
          if(donationHonorNameWrapper.length > 0 && donationHonorNameInput.val().trim().length > 0){
            props += "," + donationHonorNameInput.val().trim();
          }
        }
        else if(donationHonorWrapper.length > 0 && donationHonorDropdown.val().toLowerCase().trim() != "other"){
          props += "," + donationHonorDropdown.val().trim();
        }
      }
      else if(donationGiftWrapper.length > 0 && donationGiftWrapperInputChecked.length > 0 && donationGiftWrapperInputChecked.val().toLowerCase().trim() == "no"){
        props += ",no";
      }
    }
    
    donationWrapper.attr("data-props", props);
  }
  
  $(function(){
    let donationSwatch = $(".custom-donation-swatch-input");
    let donationGiftWrapperInput = $(".custom-donation-gift-input");
    let donationHonorDropdown = $(".custom-donation-honor-dropdown");
    
    if(donationSwatch.length > 0){
      donationSwatch.prop("checked", false);
      donationSwatch.removeClass("active");
      donationSwatch.click(function(){
        if(!$(this).hasClass("active")){
          donationSwatch.removeClass("active");
          $(this).addClass("active");
        }
        else{
          $(this).removeClass("active");
          $(this).prop("checked", false);
        }
        checkDonations();
      })
    }
  
    if(donationGiftWrapperInput.length > 0){
      donationGiftWrapperInput.change(function(){
        checkDonations();
      })
    }
  
    if(donationHonorDropdown.length > 0){
      donationHonorDropdown.change(function(){
        checkDonations();
      })
    }
  
    if($(".custom-donation-honor-name-input").length > 0){
      $(document).on("input change paste", ".custom-donation-honor-name-input", function(){
        checkDonations();
      })
    }
    
  })
  
  $(document).ready(function() {
    $('.store-name').select2();
  });
  
  $(document).on('change', '.store-name', function(e) {
    var selectedData = $(this).val();
    $('.form-store-value').val(selectedData);
  });